export default __webpack_public_path__ + "static/media/filledStar.bab6f89f.svg";